import { useQuery } from "@apollo/client";
import { apolloErrorLogger } from "@clockwise/web-commons/src/util/apolloErrorLogger";
import { useEffect } from "react";
import { PostMessageManager } from "../util/post-message.util";
import { ShouldExcludeAiQueryDocument } from "./__generated__/ShouldExcludeAI.generated";

// Sends whether the user's org excludes AI to the extension
export const useSendAIExclusion = () => {
  const { data } = useQuery(ShouldExcludeAiQueryDocument, {
    onError: (error) => {
      apolloErrorLogger({
        error,
        errorMessagePrefix: "Error loading AI Exclusion Flag for extension",
      });
    },
  });
  const shouldExcludeAi = data?.viewer?.user?.chatHistory?.shouldExcludeAi;

  useEffect(() => {
    PostMessageManager.sendShouldExcludeAi(shouldExcludeAi ?? false);
  }, [shouldExcludeAi]);
};
